export default "__VITE_ASSET__Doh2rR2Z__"